export const leiJazykySelect = [
    {
        value: 'aa',
        labelen: 'Afar',
        labelcz: 'afarština'
    },
    {
        value: 'af',
        labelen: 'Afrikaans',
        labelcz: 'afrikánština'
    },
    {
        value: 'ay',
        labelen: 'Aymara',
        labelcz: 'ajmarština'
    },
    {
        value: 'sq',
        labelen: 'Albanian',
        labelcz: 'albánština'
    },
    {
        value: 'am',
        labelen: 'Amharic',
        labelcz: 'amharština'
    },
    {
        value: 'en',
        labelen: 'English',
        labelcz: 'angličtina'
    },
    {
        value: 'ar',
        labelen: 'Arabic',
        labelcz: 'arabština'
    },
    {
        value: 'hy',
        labelen: 'Armenian',
        labelcz: 'arménština'
    },
    {
        value: 'az',
        labelen: 'Azerbaijani',
        labelcz: 'ázerbájdžánština'
    },
    {
        value: 'my',
        labelen: 'Burmese',
        labelcz: 'barmština'
    },
    {
        value: 'eu',
        labelen: 'Basque',
        labelcz: 'baskičtina'
    },
    {
        value: 'be',
        labelen: 'Belarusian',
        labelcz: 'běloruština'
    },
    {
        value: 'bn',
        labelen: 'Bengali, Bangla',
        labelcz: 'bengálština'
    },
    {
        value: 'bi',
        labelen: 'Bislama',
        labelcz: 'bislama'
    },
    {
        value: 'nb',
        labelen: 'Norwegian Bokmal',
        labelcz: 'bokmål (norština)'
    },
    {
        value: 'bs',
        labelen: 'Bosnian',
        labelcz: 'bosenština'
    },
    {
        value: 'bg',
        labelen: 'Bulgarian',
        labelcz: 'bulharština'
    },
    {
        value: 'ch',
        labelen: 'Chamorro',
        labelcz: 'čamoroština'
    },
    {
        value: 'cs',
        labelen: 'Czech',
        labelcz: 'čeština'
    },
    {
        value: 'hr',
        labelen: 'Croatian',
        labelcz: 'chorvatština'
    },
    {
        value: 'ny',
        labelen: 'Chichewa, Chewa, Nyanja',
        labelcz: 'čičeva'
    },
    {
        value: 'zh',
        labelen: 'Chinese',
        labelcz: 'čínština'
    },
    {
        value: 'tn',
        labelen: 'Tswana',
        labelcz: 'čvanština'
    },
    {
        value: 'da',
        labelen: 'Danish',
        labelcz: 'dánština'
    },
    {
        value: 'dv',
        labelen: 'Divehi, Dhivehi, Maldivian',
        labelcz: 'divehi'
    },
    {
        value: 'dz',
        labelen: 'Dzongkha',
        labelcz: 'dzongkha'
    },
    {
        value: 'et',
        labelen: 'Estonian',
        labelcz: 'estonština'
    },
    {
        value: 'fo',
        labelen: 'Faroese',
        labelcz: 'faerština'
    },
    {
        value: 'fi',
        labelen: 'Finnish',
        labelcz: 'finština'
    },

    {
        value: 'fr',
        labelen: 'French',
        labelcz: 'francouzština'
    },
    {
        value: 'gl',
        labelen: 'Galician',
        labelcz: 'galicijština'
    },
    {
        value: 'kl',
        labelen: 'Kalaallisut, Greenlandic',
        labelcz: 'grónština, kalaallisut'
    },
    {
        value: 'ka',
        labelen: 'Georgian',
        labelcz: 'gruzínština'
    },
    {
        value: 'gn',
        labelen: 'Guaraní',
        labelcz: 'guaraní'
    },
    {
        value: 'ht',
        labelen: 'Haitian, Haitian Creole',
        labelcz: 'haitská kreolština, Haitian'
    },
    {
        value: 'he',
        labelen: 'Hebrew (modern)',
        labelcz: 'hebrejština'
    },
    {
        value: 'hi',
        labelen: 'Hindi',
        labelcz: 'hindština'
    },
    {
        value: 'ho',
        labelen: 'Hiri Motu',
        labelcz: 'hiri motu'
    },
    {
        value: 'nl',
        labelen: 'Dutch',
        labelcz: 'holanština (nizozemština)'
    },
    {
        value: 'id',
        labelen: 'Indonesian',
        labelcz: 'indonéština'
    },
    {
        value: 'ga',
        labelen: 'Irish',
        labelcz: 'irština'
    },
    {
        value: 'is',
        labelen: 'Icelandic',
        labelcz: 'islandština'
    },
    {
        value: 'it',
        labelen: 'Italian',
        labelcz: 'italština'
    },
    {
        value: 'ja',
        labelen: 'Japanese',
        labelcz: 'japonština'
    },
    {
        value: 'st',
        labelen: 'Southern Sotho',
        labelcz: 'jižní sotština'
    },
    {
        value: 'ca',
        labelen: 'Catalan, Valencian',
        labelcz: 'katalánština, valencijština'
    },
    {
        value: 'kk',
        labelen: 'Kazakh',
        labelcz: 'kazaština'
    },
    {
        value: 'qu',
        labelen: 'Quechua',
        labelcz: 'kečujština'
    },
    {
        value: 'km',
        labelen: 'Khmer',
        labelcz: 'khmerština'
    },
    {
        value: 'ky',
        labelen: 'Kyrgyz',
        labelcz: 'kirgizština, Kyrgyz'
    },
    {
        value: 'ko',
        labelen: 'Korean',
        labelcz: 'korejština'
    },
    {
        value: 'kw',
        labelen: 'Cornish',
        labelcz: 'kornština'
    },
    {
        value: 'ku',
        labelen: 'Kurdish',
        labelcz: 'kurdština'
    },
    {
        value: 'lo',
        labelen: 'Lao',
        labelcz: 'laoština'
    },
    {
        value: 'lt',
        labelen: 'Lithuanian',
        labelcz: 'litevština'
    },
    {
        value: 'lv',
        labelen: 'Latvian',
        labelcz: 'lotyština'
    },
    {
        value: 'lb',
        labelen: 'Luxembourgish, Letzeburges',
        labelcz: 'lucemburština'
    },
    {
        value: 'hu',
        labelen: 'Hungarian',
        labelcz: 'maďarština'
    },
    {
        value: 'mk',
        labelen: 'Macedonian',
        labelcz: 'makedonština'
    },
    {
        value: 'ms',
        labelen: 'Malay',
        labelcz: 'malajština'
    },
    {
        value: 'mg',
        labelen: 'Malagasy',
        labelcz: 'malgaština'
    },
    {
        value: 'mt',
        labelen: 'Maltese',
        labelcz: 'maltština'
    },
    {
        value: 'mi',
        labelen: 'Maori',
        labelcz: 'maorština'
    },
    {
        value: 'mh',
        labelen: 'Marshallese',
        labelcz: 'maršalština'
    },
    {
        value: 'mn',
        labelen: 'Mongolian',
        labelcz: 'mongolština'
    },
    {
        value: 'na',
        labelen: 'Nauru',
        labelcz: 'nauruština'
    },
    {
        value: 'de',
        labelen: 'German',
        labelcz: 'němčina'
    },
    {
        value: 'ne',
        labelen: 'Nepali',
        labelcz: 'nepálština'
    },
    {
        value: 'no',
        labelen: 'Norwegian',
        labelcz: 'norština'
    },
    {
        value: 'nn',
        labelen: 'Norwegian Nynorsk',
        labelcz: 'nynorsk (norština)'
    },
    {
        value: 'om',
        labelen: 'Oromo',
        labelcz: 'oromo'
    },
    {
        value: 'ps',
        labelen: 'Pashto, Pushto',
        labelcz: 'paštština'
    },
    {
        value: 'fa',
        labelen: 'Persian (Farsi)',
        labelcz: 'perština'
    },
    {
        value: 'pl',
        labelen: 'Polish',
        labelcz: 'polština'
    },
    {
        value: 'pt',
        labelen: 'Portuguese',
        labelcz: 'portugalština'
    },
    {
        value: 'el',
        labelen: 'Greek (modern)',
        labelcz: 'řečtina'
    },
    {
        value: 'rm',
        labelen: 'Romansh',
        labelcz: 'rétorománština'
    },
    {
        value: 'ro',
        labelen: 'Romanian',
        labelcz: 'rumunština'
    },
    {
        value: 'ru',
        labelen: 'Russian',
        labelcz: 'ruština'
    },
    {
        value: 'rw',
        labelen: 'Kinyarwanda',
        labelcz: 'rwandština'
    },
    {
        value: 'sm',
        labelen: 'Samoan',
        labelcz: 'samojština'
    },
    {
        value: 'sg',
        labelen: 'Sango',
        labelcz: 'sangoština'
    },
    {
        value: 'nd',
        labelen: 'Northern Ndebele',
        labelcz: 'severní ndebelština'
    },
    {
        value: 'se',
        labelen: 'Northern Sami',
        labelcz: 'severní sámština'
    },
    {
        value: 'si',
        labelen: 'Sinhala, Sinhalese',
        labelcz: 'sinhalština, Sinhala'
    },
    {
        value: 'gd',
        labelen: 'Scottish Gaelic, Gaelic',
        labelcz: 'skotská gaelština'
    },
    {
        value: 'sk',
        labelen: 'Slovak',
        labelcz: 'slovenština'
    },
    {
        value: 'sl',
        labelen: 'Slovene',
        labelcz: 'slovinština'
    },
    {
        value: 'so',
        labelen: 'Somali',
        labelcz: 'somálština'
    },
    {
        value: 'sn',
        labelen: 'Shona',
        labelcz: 'šonština'
    },
    {
        value: 'es',
        labelen: 'Spanish, Castilian',
        labelcz: 'španělština, kastilština'
    },
    {
        value: 'sr',
        labelen: 'Serbian',
        labelcz: 'srbština'
    },
    {
        value: 'sw',
        labelen: 'Swahili',
        labelcz: 'svahilština'
    },
    {
        value: 'sv',
        labelen: 'Swedish',
        labelcz: 'švédština'
    },
    {
        value: 'tg',
        labelen: 'Tajik',
        labelcz: 'tádžičtina'
    },
    {
        value: 'tl',
        labelen: 'Tagalog',
        labelcz: 'tagalština'
    },
    {
        value: 'th',
        labelen: 'Thai',
        labelcz: 'thajština'
    },
    {
        value: 'ti',
        labelen: 'Tigrinya',
        labelcz: 'tigriňňa'
    },
    {
        value: 'to',
        labelen: 'Tonga (Tonga Islands)',
        labelcz: 'tongánština'
    },
    {
        value: 'tr',
        labelen: 'Turkish',
        labelcz: 'turečtina'
    },
    {
        value: 'tk',
        labelen: 'Turkmen',
        labelcz: 'turkmenština'
    },
    {
        value: 'uk',
        labelen: 'Ukrainian',
        labelcz: 'ukrajinština'
    },
    {
        value: 'ur',
        labelen: 'Urdu',
        labelcz: 'urdština'
    },
    {
        value: 'uz',
        labelen: 'Uzbek',
        labelcz: 'uzbečtina'
    },
    {
        value: 'cy',
        labelen: 'Welsh',
        labelcz: 'velština'
    },
    {
        value: 'vi',
        labelen: 'Vietnamese',
        labelcz: 'vietnamština'
    },
    {
        value: 'wo',
        labelen: 'Wolof',
        labelcz: 'wolofština'
    },
    {
        value: 'xh',
        labelen: 'Xhosa',
        labelcz: 'xhoština'
    },
    {
        value: 'zu',
        labelen: 'Zulu',
        labelcz: 'zulština'
    }
];
